import list from "./list";
import show from "./show";
import create from "./create";
import edit from "./edit";
import icon from "@mui/icons-material/FilterList";

const adminConfig = { list, create, edit, show, icon };

export default adminConfig;
